const LIST_PROJECT_URL = "/v1/project/list";
const PROJECT_ADD_URL = "/v1/project/add";
const PROJECT_DELETE_URL = "/v1/project/delete";
const PROJECT_UPDATE_URL = "/v1/project/update";
const PROJECT_LIST_BY_SEARCH_URL = "/v1/project/listBySearch";
const PROJECT_SINGLE = "/v1/project/single";
const PROJECT_SINGLE_BY_PCODE = "/v1/project/get";
const PROJECT_APPROVE_URL = "/v1/project/approve";
const PROJECT_UPDATE_CODE = "/v1/cart/update-project-code";




const PROJECT_API_URL_LIST = {
    LIST_PROJECT_URL,
    PROJECT_ADD_URL,
    PROJECT_DELETE_URL,
    PROJECT_LIST_BY_SEARCH_URL,
    PROJECT_UPDATE_URL,
    PROJECT_SINGLE,
    PROJECT_APPROVE_URL,
    PROJECT_UPDATE_CODE,
    PROJECT_SINGLE_BY_PCODE,
}

export {PROJECT_API_URL_LIST};